import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";

export default function ManageCashDrawer({drawer, handleSave, handleClose, saving, show}) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);

  const [isNew, setIsNew] = useState(!!!drawer?.guid);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(drawer)
  });

  const handleSaveFn = (data) => {
    handleSave(data);
  };

  return (
    <Modal onHide={handleClose} size={'md'} show={show}>
      <form onSubmit={handleSubmit(handleSaveFn)} id={'cashDrawerForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Cash Drawer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        InputLabelProps={{shrink: true}}
                        placeholder={"Drawer Name / Location"}
                        type="text"
                        {...register('name', {
                        })}
                        autoComplete="off" required
                        className="form-control" id="name"
                        label="Location Name"/>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}